import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

import { elapsedSecondsFromDateStr } from "src/utils/dates"
import { timeLeftLabel } from "src/utils/duration"
import { roundSecondsOf } from "src/utils/rounds"

import "./TikTak.css"

// Lives inside the top command bar's round block now (see Game.js). roundSeconds comes from
// src/utils/rounds.js so the countdown and RoundHandler's own deadline math never drift apart —
// this used to hardcode 60 locally, and now the length itself comes from the game (the lobby set it).
const TikTak = ({ game }) => {
  const { t } = useTranslation()
  const roundSeconds = roundSecondsOf(game)
  const remainingTime = game.tickTime ? Math.max(roundSeconds - elapsedSecondsFromDateStr(game.tickTime), 0) : roundSeconds
  const [secondsLeft, setSecondsLeft] = useState(remainingTime)
  useEffect(() => {
    if (!game.tickTime) return

    // Once the game updates, refresh instantly the seconds to avoid a little delay
    setSecondsLeft(Math.max(roundSeconds - elapsedSecondsFromDateStr(game.tickTime), 0))

    const intervalId = setInterval(() => {
      setSecondsLeft(Math.max(roundSeconds - elapsedSecondsFromDateStr(game.tickTime), 0))
    }, 250)
    return () => clearInterval(intervalId)
  }, [game.tickTime])

  const progressPct = Math.min(100, Math.max(0, (secondsLeft / roundSeconds) * 100))

  return (
    <div id="game-round">
      <div className="round-info">
        <span className="round-label">{t("game.round.label")}</span>
        <span className="round-number">{game.tick}</span>
        {game.pausedBy ? (
          // The round's clock stands still while paused; what counts down is the pause itself, which
          // lapses by itself at `pausedUntil` (security audit, 2026-10-25).
          <span className="round-countdown paused">
            ⏸{" "}
            {game.pausedUntil
              ? t("game.round.pausedFor", {
                  time: timeLeftLabel(Math.max(0, -elapsedSecondsFromDateStr(game.pausedUntil))),
                })
              : t("game.round.paused")}
          </span>
        ) : (
          // Two units at most, so a week-long round reads "6d 23h" and not a seven-figure count.
          <span className="round-countdown">{t("game.round.timeLeft", { time: timeLeftLabel(secondsLeft) })}</span>
        )}
      </div>
      {!game.pausedBy && (
        <div className="round-progress-track">
          <div className="round-progress-fill" style={{ width: `${progressPct}%` }} />
        </div>
      )}
    </div>
  )
}

export default TikTak
